<template>
	<div>
    <div class="vx-row">
      <vx-card title="Location Mapping" class="mb-4 pb-5">
				<!-- location id -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>Location ID</span>
					</div>
					<div class="w-5/6 p-4">
						<vs-input class="w-full" 
											v-model.trim="locationId" 
											placeholder="Location ID" 
											v-validate="'required'"
											name="Location ID"
											@input="(val) => (locationId = locationId.toUpperCase())"
						/>
						<span class="text-danger text-sm" v-show="errors.has('Location ID')">{{ errors.first('Location ID') }}</span>
					</div>
				</div>

        <!-- PTO Merchant  -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>PTO Name</span>
					</div>
					<div class="w-5/6 p-4">
            <v-select v-model.trim="ptoMerchant"
											:placeholder="ptoMerchantPlaceHolder"
											:options="ptoMerchants"
											v-validate="'required'"
											name="PTO Merchant"
											disabled
						></v-select>
						<span class="text-danger text-sm" v-show="errors.has('PTO Merchant')">{{ errors.first('PTO Merchant') }}</span>
          </div>
				</div>

				<!-- pto merchant code -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>PTO Location ID</span>
					</div>
					<div class="w-5/6 p-4">
						<vs-input class="w-full" 
											v-model.trim="ptoLocationId" 
											placeholder="Fill PTO location id" 
											v-validate="'required'"
											name="PTO Location ID"
											@input="(val) => (ptoLocationId = ptoLocationId.toUpperCase())"
						/>
						<span class="text-danger text-sm" v-show="errors.has('PTO Location ID')">{{ errors.first('PTO Location ID') }}</span>
					</div>
				</div>

				<!-- pto location name -->
				<div class="w-full flex flex-no-wrap">
					<div class="w-1/6 p-5">
						<span>Location Name</span>
					</div>
					<div class="w-5/6 p-4">
						<vs-input class="w-full" 
											v-model.trim="locName" 
											placeholder="Location Name" 
											name="Location Name"
											@input="(val) => (locName = locName.toUpperCase())"
						/>
					</div>
				</div>

				<!-- action button -->
				<div class="w-full text-right  p-4">
					<vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
					<vs-button id="btn-submit" class="ml-4" @click.prevent="showConfirmDialog">Submit</vs-button>
					<vs-popup  title="Are you sure with this data?" :active.sync="popupActivo">
							PTO Name: <b>{{this.ptoMerchant.label}}</b><br />
							PTO Location ID: <b>{{this.ptoLocationId}}</b><br />
							Location ID: <b>{{this.locationId}}</b><br />
							Location Name  <b>{{this.locName}}</b><br />
							<div class="w-full text-right">
									<vs-button id="btn-submit" class="mt-5 ml-4" @click.prevent="submitForm">Submit</vs-button>
							</div>
					</vs-popup>
      </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import AxiosCall from "@/global/AxiosCall";
import { url } from "@/configs/apiUrl";
export default {
	name: "EditLocationMapping",
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      ptoMerchant: '',
			ptoMerchantPlaceHolder: 'Select PTO merchant',
			ptoMerchants: [
				{
					id: 1,
					label: "KCI"
				},
				{
					id: 2,
					label: "TransJakarta"
				},
				{
					id: 3,
					label: "MRT"
				},
				{
					id: 4,
					label: 'LRT'
				},
				{
					id: 5,
					label: "Railink",
				}
			],
			ptoLocationId: '',
			locationId: '',
			locName: '',
			popupActivo: false,
    }
  },
	watch: {
		ptoMerchant(value) {
			if(value == '' || value == null) {
				this.ptoMerchant = '';
			}
		},
		locationId(value) {
			if(value[0] == 1) {
				this.ptoMerchant = this.ptoMerchants[0];
			}else if (value[0] == 2) {
				this.ptoMerchant = this.ptoMerchants[1];
			}else if (value[0] == 3) {
				this.ptoMerchant = this.ptoMerchants[2];
			}else if (value[0] == 4) {
				this.ptoMerchant = this.ptoMerchants[3];
			}else if (value[0] == 5) {
				this.ptoMerchant = this.ptoMerchants[4];
			}else {
				this.ptoMerchant = '';
				this.ptoMerchantPlaceHolder = 'PTO not found'
			}
		},
	},
	methods: {
		backPage() {
			this.$router.push({name: 'LocationMapping'})
		},
		removeSpacing(str) {
			return str.toString().replace(/\s/g, '')
		}, 
		showConfirmDialog() {
			this.$validator.validateAll()
				.then((res) => {
					if(res) {
						this.popupActivo = true;
					}
				})
		},
		submitForm()  {
			this.$validator.validateAll()
				.then((res) => {
					this.popupActivo = false;
					if(res) {
						let payload = {
							pto_id: this.ptoMerchant.id,
							pto_loc_id: this.ptoLocationId,
							loc_id: this.locationId,
							loc_name: this.locName
						}
						AxiosCall.Put(url.svd.location_mapping.update + "/" + this.$route.params.locationMappingId, payload)
							.then((res) => {
								if(res.message_code === 'E_INVALID_PARAMETER') {
									this.$vs.notify({
                        title: "Warning",
                        text: res.message,
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
								}else {
									this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Location Mapping",
                            activity: "Edit location mapping",
                            data_before: this.$route.params.currentLocationMapping,
                            data_after: payload,
                        })
                        let status = true
                        this.$router.push({name: "LocationMapping", params: {status: status, message: 'Edit location mapping success'}})
								}
							}, (error) => {
								this.$vs.notify(error.response.data.notify)
							})
					}
				})
		},
	},
	mounted() {
			if(this.$route.params.currentLocationMapping === undefined) {
				location.href = "/location-mapping"
			}else {
				// initial value for pto merchant
				for(let data of this.ptoMerchants) {
					if(data.id == this.$route.params.currentLocationMapping.pto_id) {
						this.ptoMerchant = data;
					}
				}
				this.ptoLocationId = this.$route.params.currentLocationMapping.pto_loc_id;
				this.locationId = this.$route.params.currentLocationMapping.loc_id;
				this.locName = this.$route.params.currentLocationMapping.loc_name;
			}

		}
}
</script>

<style>
.con-vs-popup .vs-popup {
  width: 350px !important;
  height: auto !important;
}

</style>
